module.exports = __webpack_public_path__ + "BG-02.44384bb.basis";